import React, {useEffect, useState} from "react";
import {Button, Col, DatePicker, Form, Image, Input, message, Row, Tabs, TabsProps, Upload, UploadProps} from "antd";
import {useStore} from "../../store";
import {forEach} from "lodash";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import { addImageInfo, editImageInfo, uploadImages } from "../../http/manager";
import {observer} from "mobx-react";
import styled from "styled-components";
import {UploadOutlined} from "@ant-design/icons";
import {BaseImageUrl} from "../../http/http";

interface PictureProps {
    onSuccess: ()=> void;
}

const defaultIcon = require("../../image/default-pic.png")

const Picture:React.FC<PictureProps> = ({onSuccess}) => {

    const [form] = Form.useForm();
    const {PictureStore} = useStore();

    useEffect(() => {
        if (PictureStore.detailType === "edit") {
            const { showBaseLibraryDetail } = PictureStore;
            const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));

            form.setFieldsValue(detail);
        }
        PictureStore.setSrcFile(null)
        PictureStore.clearFileList();
        // return form.resetFields();
    }, []);

    const props: UploadProps = {
        onRemove: (file) => {
        },
        beforeUpload: (file) => {
            PictureStore.setFilelist(file);
            fileToBase(file);
            return false;
        },
    };

    const fileToBase = (file:any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const src = reader.result;
            PictureStore.setSrcFile(src);
        }
    }

    const pictureForm = () => {
        return <Form  form={form} layout={"vertical"} size={"middle"} style={{maxHeight: "400px", overflowY: "auto", overflowX:"hidden"}}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"中文名:"} name={"cnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"拉丁文:"} name={"ldName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属中文名:"} name={"genCnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属拉丁文:"} name={"genLdName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"科中文名:"} name={"specCnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"科拉丁名:"} name={"specLdName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"图片地址:"} name={"imgUrl"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Upload style={{marginTop:"15px" , marginBottom: "15px"}} showUploadList={false} name={"picture"} maxCount={1} listType="picture-card" {...props} >
                        {(PictureStore.showBaseLibraryDetail?.imgUrl || PictureStore.srcFile )? <Image preview={false} src={PictureStore.srcFile ? PictureStore.srcFile : BaseImageUrl+PictureStore.showBaseLibraryDetail?.imgUrl} fallback={defaultIcon}/> : <UploadOutlined/>}
                    </Upload>
                </Col>
            </Row>
        </Form>
    }

    const submit = () => {
        const formFields = form.getFieldsValue(true);
        const formKeys = Object.keys(formFields);
        if (PictureStore.detailType === "add" && PictureStore.fileList.length <= 0) {
            message.error("请选择照片");
            return;
        }
        form.validateFields(formKeys)
            .then(() => {
                const formData = new FormData();
                forEach(formKeys, (key) => {
                    formData.append(key, formFields[key]);
                })
                showFullScreenLoading()

                if (PictureStore.detailType === "add") {
                    addImageInfo(formData)
                        .then((res:any) => {
                            if (Number(res.code) === 200) {
                                uploadPicture();
                            } else {
                                tryHideFullScreenLoading();
                                message.error("新增失败");
                            }
                        }).catch(() => {
                        message.error("新增失败");
                        tryHideFullScreenLoading()
                    })
                } else {
                    editImageInfo(formData)
                        .then((res:any) => {
                            if (Number(res.code) === 200) {
                                if (PictureStore.fileList.length <= 0) {
                                    message.success("编辑成功");
                                    tryHideFullScreenLoading()
                                    onSuccess();
                                } else {
                                    uploadPicture(false);
                                }
                            } else {
                                tryHideFullScreenLoading();
                                message.error("编辑失败");
                            }
                        }).catch(() => {
                        message.error("编辑失败");
                        tryHideFullScreenLoading()
                    })
                }
            })
            .catch();
    }

    const uploadPicture = (isAdd = true) => {
        const params = new FormData();
        params.append("file", PictureStore.fileList[0]);
        params.append("watermark", '0');
        params.append("type", '3');
        uploadImages(params)
            .then((res:any) => {
                tryHideFullScreenLoading()
                if (Number(res.code) === 200) {
                    message.success(isAdd? "新增成功" : "编辑成功");
                    onSuccess();
                } else {
                    message.error(isAdd? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
                }
            }).catch(() => {
            message.error(isAdd? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
            tryHideFullScreenLoading()
        })
    }

    return (<Wrapper>
        <div style={{paddingBottom:"16px"}}>
            { pictureForm() }
        </div>
        <Button onClick={submit} type={"primary"} style={{width: "70px", left: "630px"}}>提交</Button>
    </Wrapper>);
}

export default observer(Picture);

const Wrapper = styled.div`
    & {
      display: flex;
      flex-direction: column;
      .ant-picker{
        width: 100%;
      }
    }
`;